document.querySelectorAll('[data-monti-locale]').forEach((root) => {
  const toggle = root.querySelector('.monti-locale__toggle');
  const panel = root.querySelector('.monti-locale__panel');
  const backdrop = root.querySelector('.monti-locale__backdrop');
  const form = root.querySelector('form');
  if (!toggle || !panel || !form) return;

  const setOpen = (open) => {
    panel.hidden = !open;
    if (backdrop) backdrop.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('monti-locale-open', open);
    if (open) panel.focus({ preventScroll: true });
  };

  toggle.addEventListener('click', () => setOpen(panel.hidden));
  backdrop?.addEventListener('click', () => setOpen(false));
  document.addEventListener('click', (event) => {
    if (!panel.hidden && !root.contains(event.target)) setOpen(false);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !panel.hidden) {
      setOpen(false);
      toggle.focus();
    }
  });

  root.querySelectorAll('.monti-locale__option').forEach((option) => {
    option.addEventListener('click', () => {
      if (option.dataset.language) form.querySelector('[data-monti-locale-language]').value = option.dataset.language;
      if (option.dataset.country) form.querySelector('[data-monti-locale-country]').value = option.dataset.country;
      form.submit();
    });
  });
});
